<div
  class="hidden font-semibold text-xs text-neutral-500 md:flex gap-x-1 items-center"
>
  <button
    routerLink="/home"
    class="btn btn-link p-0 no-underline text-neutral-500"
  >
    <span>Home</span>
  </button>
  <i class="fa-solid fa-chevron-right"></i>
  <button class="btn btn-link p-0 no-underline text-neutral-500">
    <span>Services</span>
  </button>
</div>

<h1 class="font-extrabold text-4xl">Services</h1>
<p>Discover all our products and services.</p>

<!-- <div class="flex mt-5 w-full">
  <div
    role="tablist"
    class="tabs tabs-boxed flex shadow font-semibold bg-white dark:bg-base-100 rounded-box p-2 w-full"
  >
    <a role="tab" class="tab flex-1 rounded-box tab-active">Payment</a>
    <a role="tab" class="tab flex-1 rounded-box">Airtime and Data</a>
    <a role="tab" class="tab flex-1 rounded-box">Bills and Utilities</a>
  </div>
</div> -->

<div class="flex flex-col gap-y-2 mt-5">
  <div class="collapse collapse-arrow bg-white dark:bg-base-100">
    <input type="checkbox" name="services" checked />
    <div class="collapse-title font-normal">Payment</div>
    <div class="collapse-content bg-base-200">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 my-4">
        <button
          class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{ t("new_payment") }}</span>
        </button>
        <button
          class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{
            t("check_transaction")
          }}</span>
        </button>
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{ t("send_money") }}</span>
        </button>
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{
            t("check_balance")
          }}</span>
        </button>
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{
            t("momo_to_bank")
          }}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="collapse collapse-arrow bg-white dark:bg-base-100">
    <input type="checkbox" name="services" checked />
    <div class="collapse-title font-normal">Airtime and Data</div>
    <div class="collapse-content bg-base-200">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 my-4">
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm">Buy Airtime</span>
        </button>
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm">Buy Data</span>
        </button>
      </div>
    </div>
  </div>
  <div class="collapse collapse-arrow bg-white dark:bg-base-100">
    <input type="checkbox" name="services" checked />
    <div class="collapse-title font-normal">Bills and Utilities</div>
    <div class="collapse-content bg-base-200">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 my-4">
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-circle-plus text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{
            t("renew_canalbox")
          }}</span>
        </button>
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-plug-circle-bolt text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{
            t("electricity_bill")
          }}</span>
        </button>
        <button
          class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
        >
          <i class="fa-solid fa-droplet text-4xl"></i>
          <span class="text-sm" *transloco="let t">{{ t("water_bill") }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <div class="mt-5 mb-2">
  <h3 class="text-xs md:text-base uppercase">Payment</h3>
</div>
<div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 mb-4">
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">Send Money</span>
  </button>
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">Request Payment</span>
  </button>
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">Check Balance</span>
  </button>
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">MoMo to Bank</span>
  </button>
</div>

<div class="mt-5 mb-2">
  <h3 class="text-xs md:text-base uppercase">Airtime and Data</h3>
</div>
<div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 mb-4">
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">Buy Airtime</span>
  </button>
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">Buy Data</span>
  </button>
</div>

<div class="mt-5 mb-2">
  <h3 class="text-xs md:text-base uppercase">Bills and Utilities</h3>
</div>
<div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 mb-4">
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">Renew CanalBox</span>
  </button>
  <button
    class="size-full btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex flex-col justify-center items-center gap-3 p-3 rounded-box hover:dark:md:bg-base-200 hover:md:bg-primary hover:md:text-white"
  >
    <i class="fa-solid fa-circle-plus text-4xl"></i>
    <span class="text-sm">Pay Bills</span>
  </button>
</div> -->

<qwiko-all-services></qwiko-all-services>
